"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCommonRecord = getCommonRecord;

function getCommonRecord() {
  return [{
    "value": "接种第一次疫苗"
  }, {
    "value": "接种第二次疫苗"
  }, {
    "value": "接种第三次疫苗"
  }, {
    "value": "接种年度疫苗例行疫苗"
  }, {
    "value": "内外驱虫一次"
  }, {
    "value": "内驱虫一次"
  }, {
    "value": "外驱虫一次"
  }, {
    "value": "接受体检"
  }];
}